import { all, fork } from "redux-saga/effects";
import Attendance from "./attendance/attendance-sagas";
import DocumentsSagas from "./document/document-sagas";
import LobbySagas from "./lobby/lobby-sagas";
import LocationSagas from "./location/location-sagas";
import MultipleRealmsSagas from "./multiple-realms/multiple-realms-sagas";
import NpsSagas from "./nps/nps-sagas";
import ProcessSagas from "./process/process-sagas";
import ReadersSagas from "./readers-tags/readers/readers-sagas";
import TagsSagas from "./readers-tags/tags/tags-sagas";
import ReportSagas from "./report/report-sagas";
import UserSessionSagas from "./user-session/user-session-sagas";
import UsersSagas from "./users/users-sagas";
import VehicleDashboardSagas from "./vehicle-dashboard/vehicle-dashboard-sagas";

export default function* sagaConfig() {
  yield all([
    fork(LobbySagas),
    fork(ReportSagas),
    fork(LocationSagas),
    fork(UserSessionSagas),
    fork(UsersSagas),
    fork(DocumentsSagas),
    fork(ProcessSagas),
    fork(Attendance),
    fork(VehicleDashboardSagas),
    fork(MultipleRealmsSagas),
    fork(NpsSagas),
    fork(TagsSagas),
    fork(ReadersSagas),
  ]);
}
